module.exports = __webpack_public_path__ + "img/subject_bg_left.3062cd00.png";